var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4A5569"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.641 1.651l-8.445 8.05c-.605.579-1.4.867-2.196.867-.795 0-1.59-.29-2.196-.866L.359 1.65C.133 2.024 0 2.46 0 2.928v11.104C0 15.39 1.1 16.5 2.444 16.5h17.112C20.9 16.5 22 15.39 22 14.032V2.928c0-.467-.133-.903-.359-1.277z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.376 8.278L20.9.325A2.481 2.481 0 0019.674 0H2.326C1.88 0 1.462.12 1.1.325l8.524 7.953c.746.697 2.006.696 2.752 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3a52ea21.svg";
export { ForwardRef as ReactComponent };